import React from 'react'
import Img from 'gatsby-image'
import { Link } from 'gatsby'
import Phone from './Phone'
import LargeCTAStyles from '../../styles/LargeCTA.module.sass'

/**
 * Display a call-to-action section
 *
 * @param {string} title
 * @param {string} text
 * @param {string} buttonText Button label
 * @param {string} imageURL
 */
const LargeCTA = props => {
  return (
    <div className={`large-cta ${LargeCTAStyles.cta || ''}`}>
      <div className={`container ${LargeCTAStyles.container || ''}`}>
        <div className={LargeCTAStyles.content || ''}>
          <p className={`title is-4 ${LargeCTAStyles.title || ''}`}>
            {props.title || ''}
          </p>
          <p className={LargeCTAStyles.text}>
            {props.text ||
              ''}
          </p>
          <div className={`buttons ${LargeCTAStyles.buttons || ''}`}>
            <Link to="/contact/" className="button is-primary with-decoration-right">
              {props.buttonText || 'Get a Callout'}
            </Link>
            {props.hidePhone !== 'true' && <Phone class="button is-black with-decoration-left"/>}
          </div>
        </div>
        {props.image ? (
          props.image.childImageSharp ? (
            <Img
              fluid={props.image.childImageSharp.fluid}
              alt={props.title || ''}
              title={props.title || ''}
              className={LargeCTAStyles.image}
            />
          ) : (
            <img
              src={props.image}
              alt={props.title || ''}
              title={props.title || ''}
              className={LargeCTAStyles.image}
            />
          )
        ) : null}
      </div>
    </div>
  )
}

export default LargeCTA
